import React from 'react';
import PropTypes from 'prop-types';
import { Image } from 'edcom-ui';

import styles from './Carousel.module.less';

export default function CarouselItem({
  touchStartCallback,
  touchMoveCallback,
  clickHandler,
  lazyLoad,
  primaryImage,
  secondaryImage,
  title,
  description,
}) {
  return (
    <div
      className={styles.carouselItem}
      onTouchStart={e => touchStartCallback(e)}
      onTouchMove={e => touchMoveCallback(e)}
    >
      <div className={styles.leftSide} onClick={clickHandler}>
        <Image
          lazy={lazyLoad}
          src={primaryImage}
          alt="Descriptive image of resource"
          aria-hidden="true"
        />
      </div>
      <div className={styles.rightSide}>
        {secondaryImage && (
          <Image src={secondaryImage} alt="" aria-hidden="true" />
        )}
        <div onClick={clickHandler}>
          <h3>{title}</h3>
          <div className={styles.highlight}>{description}</div>
        </div>
      </div>
    </div>
  );
}

CarouselItem.propTypes = {
  title: PropTypes.string,
  primaryImage: PropTypes.string,
  secondaryImage: PropTypes.string,
  description: PropTypes.string,
  css: PropTypes.string,
  touchStartCallback: PropTypes.func,
  touchMoveCallback: PropTypes.func,
  lazyLoad: PropTypes.bool.isRequired,
  clickHandler: PropTypes.func,
};
